export default "__VITE_ASSET__Cm16fOvW__"